import { ROLES } from "../../auth/constants";

const config = {
  SITE: 'sustainability-nonprod',
  LABEL: 'Sustainability',
  SITE_ID: 'groups.coca-cola.com,18f2d0a2-e373-4c4a-b16f-64378e8812b8,95de911e-0029-4457-9ced-5accddb647f0',
  PAGES_LIST_ID: 'b2efb5db-2503-4c4f-afd6-bd311bddac3c',
  DOCUMENTS_LIST_ID: '91db065d-a4b3-4dbd-a104-37184fbfc975',
  SITE_ASSETS_DRIVE_ID: 'b!otDyGHPjSkyxb2Q3jogSuB6R3pUpAFdEnO1azN22R_BZz1PLTXK0QbIgYyn3j08T',
  DOCUMENTS_DRIVE_ID: 'b!otDyGHPjSkyxb2Q3jogSuB6R3pUpAFdEnO1azN22R_BdBtuRs6S9TaEENxhPv8l1',
  NEWS_TEMPLATE_ID: '4d0dd9b4-c852-4a81-8720-3a0e5789f0f7',
  SETTINGS_FILE_PATH: 'Settings/HubSettings.json',
  MANAGER_ROLES: [ROLES.QSE_SUSTAINABILITY_MGR],
  VIVA_COMMUNITY_ID: undefined
}

export default config